import liff from '@line/liff'
import { APP_LIFF_ID } from 'src/constants/env-constant'

class LiffService {
  private liffId: string = APP_LIFF_ID || ''
  private initialized = false

  async init() {
    if (this.initialized) return

    if (!this.liffId) {
      throw new Error('LIFF IDが設定されていません。')
    }

    await liff.init({ liffId: this.liffId })
    this.initialized = true
  }

  get isLogin() {
    return liff.isLoggedIn()
  }

  login() {
    if (!liff.isLoggedIn()) {
      liff.login({
        redirectUri: window.location.href,
      })
    }
  }

  logout() {
    if (liff.isLoggedIn()) {
      liff.logout()
      window.location.reload()
    }
  }

  getIDToken() {
    return liff.getIDToken()
  }

  async getProfile() {
    if (!liff.isLoggedIn()) {
      throw new Error('LINEにログインしていません。')
    }

    return liff.getProfile()
  }

  close() {
    liff.closeWindow()
  }

  getLanguage() {
    return liff.getLanguage()
  }

  getVersion() {
    return liff.getVersion()
  }

  isInClient() {
    return liff.isInClient()
  }

  async getFriendship() {
    return liff.getFriendship()
  }
}

export default new LiffService()
